import { BundleResourcesPackage } from "resource-system";
import { Spritesheet } from "pixi.js";
import { Texture } from "@pixi/core";
export class CommonResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("CommonResourcesPackage");
    }
    public get assets_common_common_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/common/common_1x.atlas.json");
    }
    public get assets_common_languages_background_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["languages_background.png"];
    }
    public get assets_common_violet_placeholder_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["violet_placeholder.png"];
    }
    public get assets_common_multiplier_ad_substrate_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["multiplier_ad/substrate.png"];
    }
    public get assets_common_multiplier_ad_ad_button_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["multiplier_ad/ad_button.png"];
    }
    public get assets_common_button_background_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["button_background.png"];
    }
    public get assets_common_coints_substrate_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["coints_substrate.png"];
    }
    public get assets_common_close_button_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["close_button.png"];
    }
    public get assets_common_weapons_selected_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["weapons/selected.png"];
    }
    public get assets_common_boosters_booster_substrate_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/booster_substrate.png"];
    }
    public get assets_common_vegetables_icon_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["vegetables_icon.png"];
    }
    public get assets_common_boosters_turret_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/turret.png"];
    }
    public get assets_common_multiplier_ad_timer_bar_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["multiplier_ad/timer_bar.png"];
    }
    public get assets_common_multiplier_ad_timer_background_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["multiplier_ad/timer_background.png"];
    }
    public get assets_common_weapons_boomerang_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["weapons/boomerang.png"];
    }
    public get assets_common_boosters_mine_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/mine.png"];
    }
    public get assets_common_boosters_freeze_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/freeze.png"];
    }
    public get assets_common_weapons_dynamite_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["weapons/dynamite.png"];
    }
    public get assets_common_boosters_energy_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/energy.png"];
    }
    public get assets_common_home_icon_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["home_icon.png"];
    }
    public get assets_common_weapons_rock_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["weapons/rock.png"];
    }
    public get assets_common_multiplier_ad_reward_background_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["multiplier_ad/reward_background.png"];
    }
    public get assets_common_restart_icon_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["restart_icon.png"];
    }
    public get assets_common_sound_off_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["sound_off.png"];
    }
    public get assets_common_sound_on_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["sound_on.png"];
    }
    public get assets_common_music_off_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["music_off.png"];
    }
    public get assets_common_music_on_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["music_on.png"];
    }
    public get assets_common_coin_icon_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["coin_icon.png"];
    }
    public get assets_common_language_icons_cs_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["language_icons/cs.png"];
    }
    public get assets_common_language_icons_de_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["language_icons/de.png"];
    }
    public get assets_common_language_icons_en_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["language_icons/en.png"];
    }
    public get assets_common_language_icons_es_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["language_icons/es.png"];
    }
    public get assets_common_language_icons_fr_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["language_icons/fr.png"];
    }
    public get assets_common_language_icons_it_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["language_icons/it.png"];
    }
    public get assets_common_language_icons_ja_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["language_icons/ja.png"];
    }
    public get assets_common_language_icons_pl_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["language_icons/pl.png"];
    }
    public get assets_common_language_icons_ru_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["language_icons/ru.png"];
    }
    public get assets_common_boosters_ad_substrate_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/ad_substrate.png"];
    }
    public get assets_common_boosters_counter_substrate_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/counter_substrate.png"];
    }
    public get assets_common_boosters_levels_icons_3_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/levels_icons/3.png"];
    }
    public get assets_common_boosters_levels_icons_4_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/levels_icons/4.png"];
    }
    public get assets_common_boosters_levels_icons_1_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/levels_icons/1.png"];
    }
    public get assets_common_boosters_levels_icons_2_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/levels_icons/2.png"];
    }
    public get assets_common_boosters_levels_icons_5_png(): Texture {
        return this.assets_common_common_1x_atlas_json.textures["boosters/levels_icons/5.png"];
    }
    public get assets_common_common_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/common/common_1x.atlas.png");
    }
}

